import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useConsent } from '../../hooks/useConsent';
import { ConversionEvents } from '../../services/marketingEvents';
import { loadMarketingAttribution } from '../../services/marketingTracking';
import { readFounderSupportSession } from '../../utils/founderSupportSession';
import { resolveRouteSEO } from './RouteSEO';
import { isSensitiveCredentialRoute } from '../../utils/sensitiveRoutePrivacy';

const MarketingFunnelTracker = () => {
  const { pathname } = useLocation();
  const { state, hasConsent } = useConsent();

  useEffect(() => {
    // A Platform Admin support session must never be attributed to the
    // Founder or counted as a public conversion while its redirect settles.
    if (readFounderSupportSession() || isSensitiveCredentialRoute(pathname)) return;

    const route = resolveRouteSEO(pathname);
    if (route.noindex || !hasConsent('analytics')) return;

    let active = true;

    const recordPublicEntry = async () => {
      try {
        const { captureAttribution, trackConversionOnce } = await loadMarketingAttribution();

        if (!active) return;

        captureAttribution();
        trackConversionOnce(
          ConversionEvents.LANDING_VIEW,
          'public-entry',
          undefined,
          { path: route.canonicalPath },
        );
      } catch {
        // Measurement must never interrupt the public founder flow.
      }
    };

    void recordPublicEntry();

    return () => {
      active = false;
    };
  }, [hasConsent, pathname, state]);

  return null;
};

export default MarketingFunnelTracker;
